import { render, staticRenderFns } from "./MbInstanceViewer.vue?vue&type=template&id=724cd861&scoped=true"
import script from "./MbInstanceViewer.vue?vue&type=script&lang=js"
export * from "./MbInstanceViewer.vue?vue&type=script&lang=js"
import style0 from "./MbInstanceViewer.vue?vue&type=style&index=0&id=724cd861&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724cd861",
  null
  
)

export default component.exports